import { jsx as _jsx } from "react/jsx-runtime";
import { useLocale } from '../context/LocaleContext';
export const LanguageSwitcher = ({ variant = 'header' }) => {
    const { locale, setLocale } = useLocale();
    return (_jsx("div", { className: `lang-switch ${variant}`, children: ['ja', 'en'].map(l => (_jsx("button", { "aria-label": `Switch language to ${l}`, className: `lang-btn ${locale === l ? 'active' : ''}`, onClick: () => setLocale(l), children: l === 'ja' ? '日本語' : 'EN' }, l))) }));
};
